import { render } from "./ProgressHalfIcon.vue?vue&type=template&id=574c1f5d&ts=true"
import script from "./ProgressHalfIcon.vue?vue&type=script&lang=ts"
export * from "./ProgressHalfIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__